import React from 'react';

import XdsButton from '../XdsButton/XdsButton';
import { requestAppReload as requestAppReloadAction } from '../../api/actions/navigation';
import { useLocalization } from '../../hooks/localization';

interface Props {
  requestAppReload: Dispatch<typeof requestAppReloadAction>;
}

const ErrorSwitchTabContent = ({ requestAppReload }: Props) => {
  const t = useLocalization();
  return (
    <div className="text-center">
      <h2 className="font-500 text-headline1 md:font-300">
        {t('error_tabs_header')}
      </h2>
      <p className="pt-8 pb-10 m-auto text-neutral2-base max-w-4/5 md:max-w-3/5">
        {t('error_tabs_body')}
      </p>
      <XdsButton
        tone="theme1"
        onClick={() => requestAppReload()}
      >
        {t('error_tabs_restartTest')}
      </XdsButton>
    </div>
  );
};

export default ErrorSwitchTabContent;
